<template>
  <canvas ref="chartContainer" :width="width" :height="height"></canvas>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: 'LineChart',
  props: {
    width: {
      type: Number
    },
    height: {
      type: Number
    },
    labels: Array,
    datasets: {
      type: Array,
      default: function() {
        return []
      }
    },
    options: Object
  },
  data () {
    return {
      chart: null
    }
  },
  mounted () {
    /*Chart.defaults._set('global', {
      defaultColor: 'rgb(255,255,255,.8)',
      defaultFontColor: '#FFF',
      elements: {
        line: {
          backgroundColor: 'rgba(255,255,255,.2)',
          borderColor: 'rgba(255,255,255,.8)'
        },
        point: {
          backgroundColor: 'rgba(255,255,255,.2)',
          borderColor: 'rgba(255,255,255,.8)'
        }
      },
    });
    window.Chart.defaults.scale.gridLines.color = 'rgba(255,255,255,.8)'
    window.Chart.defaults.global.legend.display = false
    window.Chart.defaults.scale.gridLines.zeroLineColor = 'rgba(255,255,255,0)'
    //window.Chart.defaults.elements.line.backgroundColor = 'rgb(255,255,255,.2)'*/
    this.chart = new Chart(this.$refs.chartContainer, {
      type: 'line',
      data: {
        labels: this.labels,
        datasets: this.datasets
      },
      options: this.options
    })
  },
  watch: {
    datasets(newDatasets) {
      this.chart.data.datasets = newDatasets
      this.chart.update()
    },
    options: {
      handler: function(newOptions) {
        this.chart.options = newOptions
        this.chart.update()
      },
      deep: true
    }
  },
  beforeDestroy () {
    if (this.chart) this.chart.destroy()
  }
}
</script>